"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileManagement = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const button_1 = require("primereact/button");
const react_i18next_1 = require("react-i18next");
require("../style/file-management.css");
const image_1 = require("primereact/image");
const CustomConfirmDialog_1 = require("./CustomConfirmDialog");
const Global_1 = require("../functions/Global");
const CustomToast_1 = require("./CustomToast");
const CustomWaitAnimation_1 = require("./CustomWaitAnimation");
const FileManagement = (props) => {
    const inputFile = (0, react_1.useRef)(null);
    const { t } = (0, react_i18next_1.useTranslation)(['common']);
    const [files, setFiles] = (0, react_1.useState)([]);
    const [selectedContent, setSelectedContent] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        _getFiles();
    }, []);
    const _getFiles = () => {
        (0, CustomWaitAnimation_1.showWaitAnimation)();
        (0, Global_1.getFiles)(props.project_id, props.keycloakfetch, props.settings).then(result => {
            for (let j = 0; j < result.length; j++) {
                const file = result[j];
                file.size = base64ToBytes(file.data);
                console.log(file.size);
            }
            setFiles(result);
            (0, CustomWaitAnimation_1.hideWaitAnimation)();
        });
    };
    const base64ToBytes = (base64) => {
        if (base64) {
            return 4 * Math.ceil((base64.length / 3)) * 0.5624896334383812;
        }
        else {
            return undefined;
        }
    };
    const getSizeString = (bytes) => {
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return `${parseFloat((bytes / Math.pow(1024, i)).toFixed(2))} ${sizes[i]}`;
    };
    const chooseFile = (e) => {
        if (inputFile.current !== null) {
            inputFile.current.click();
        }
    };
    const getBase64 = (file, cb) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };
    const uploadFile = (e) => {
        if (e.target.files[0].size > 1000000) {
            (0, CustomToast_1.showMessageOnError)(t('error'), t('fileMg_fileExceed1MbLimitError'));
        }
        else {
            getBase64(e.target.files[0], (result) => {
                const arr = result.split('base64,');
                if (arr.length === 2) {
                    const split = e.target.files[0].name.split('.');
                    const extension = split[split.length - 1].toLowerCase();
                    let file_type_id = 0;
                    switch (extension) {
                        case 'png':
                            file_type_id = 0;
                            break;
                        case 'jpg':
                        case 'jpeg':
                            file_type_id = 1;
                            break;
                    }
                    const body = {
                        project_id: props.project_id,
                        file_type_id: file_type_id,
                        data: arr[1],
                        name: e.target.files[0].name
                    };
                    (0, CustomWaitAnimation_1.showWaitAnimation)();
                    (0, Global_1.insertFile)(body, props.keycloakfetch, props.settings).then(result => {
                        (0, CustomWaitAnimation_1.hideWaitAnimation)();
                        if (result.error) {
                            (0, CustomToast_1.showMessageOnError)(t('error'), t(result.error));
                        }
                        else {
                            (0, CustomToast_1.showMessageOnSuccess)(t('success'), t('toasts_fileUploaded'));
                            _getFiles();
                        }
                    });
                }
            });
        }
    };
    const showFile = (file) => {
        let content;
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(file.size) / Math.log(1024));
        const sizeStr = `${parseFloat((file.size / Math.pow(1024, i)).toFixed(2))} ${sizes[i]}`;
        switch (file.type_name.toLowerCase()) {
            case 'png':
            case 'jpeg':
            case 'jpg':
                content = ((0, jsx_runtime_1.jsx)(image_1.Image, { className: "fm-image", src: 'data:image/' + file.type_name + ';base64, ' + file.data, preview: true, width: "80" }));
                break;
        }
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-auto" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'm-3 p-1 fm-content' + (selectedContent === file.id ? ' selected' : ''), onClick: () => {
                    setSelectedContent(file.id);
                    if (props.onSelect) {
                        props.onSelect(file.id, file.size);
                    }
                } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "mt-2" }, { children: content })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "fm-filename" }, { children: file.name })), (0, jsx_runtime_1.jsx)("div", { children: '(' + sizeStr + ')' }), (0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-times", className: "p-button-rounded p-button-danger p-button-text fm-delete-button", "aria-label": "Delete", onClick: () => {
                            (0, CustomConfirmDialog_1.CustomConfirmDialog)({
                                message: t('dialogs_removeElementFileMessage'),
                                header: t('confirmation'),
                                translation: t,
                                onConfirm: () => {
                                    (0, Global_1.deleteFile)(props.project_id, file.id, props.keycloakfetch, props.settings).then(result => {
                                        if (result.error) {
                                            (0, CustomToast_1.showMessageOnError)(t('error'), t('error_' + result.error));
                                        }
                                        else {
                                            (0, CustomToast_1.showMessageOnSuccess)(t('success'), t('projM_fileDeleted'));
                                            _getFiles();
                                        }
                                    });
                                }
                            });
                        } })] })) })));
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "fm grid grid-nogutter mt-3" }, { children: [props.maxSize && (0, jsx_runtime_1.jsx)("div", { children: getSizeString(props.maxSize) }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "grid grid-nogutter col fm-body" }, { children: files && files.map((file) => {
                    return showFile(file);
                }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "fm-button-controls p-2" }, { children: [(0, jsx_runtime_1.jsx)("input", { type: "file", id: "file", ref: inputFile, accept: ".png, .jpeg, .jpg", onInput: uploadFile, style: { display: 'none' } }), (0, jsx_runtime_1.jsx)(button_1.Button, { className: "p-button p-button-outlined", style: { backgroundColor: 'white' }, icon: "pi pi-plus", onClick: chooseFile })] }))] })));
};
exports.FileManagement = FileManagement;
